import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, type OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CustomFieldInputComponent } from 'src/app/components/custom-field-input/custom-field-input.component';
import { CustomFieldsConstants } from 'src/app/constants/CustomFieldsConstants';
import { CustomFieldDTO } from 'src/app/DTO/CustomFieldDTO';

@Component({
  selector: 'app-custom-fields-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CustomFieldInputComponent
  ],
  templateUrl: './CustomFieldsForm.component.html',
  styleUrl: './CustomFieldsForm.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomFieldsFormComponent implements OnInit {

  @Input() customFields: CustomFieldDTO[];
  @Input() formGroup: FormGroup;
  @Input() formBuilder: FormBuilder
  @Input() submitAttempted: boolean;

  @Output() priceChanged: any = new EventEmitter();
  @Output() onError = new EventEmitter();

  public fieldTypes = CustomFieldsConstants.InputTypes;

  ngOnInit(): void {
    if (this.customFields?.length > 0) {
      this.customFields = this.customFields.filter(x => x.publicPermissions.includes('w'))

      const typesArray = Object.values(this.fieldTypes);

      const noWhitespaceValidator = (control: FormControl) => {
        const isWhitespace = (control.value || '').toString().trim().length === 0;
        return !isWhitespace ? null : { whitespace: true };
      };

      for (const customField of this.customFields) {
        if (!typesArray.includes(customField.type as CustomFieldsConstants.InputTypes)) {
          this.onError.emit();
        }
        let value = null;

        this.formGroup.addControl(customField.id.toString(), this.formBuilder.control(value, customField.required ? [Validators.required, noWhitespaceValidator] : null));
      }
    }
  }

}
